<template>
    <div class="test">
        <v-expansion-panel v-model="tournamentPanel" expand dark>
            <v-expansion-panel-content class="blue darken-4" v-for="item in tournaments" :key="item.id">
                <div slot="header" class="tournament-title">
                    {{item.tournament}}
                </div>
                <v-card>
                    <v-card-text class="grey darken-3">
                        <v-expansion-panel class="mb-0 full-white-border">
                            <v-expansion-panel-content class="grey darken-2" v-for="event in item.events" :key="event.fixtureId">
                                <div slot="header" class="white-color">
                                    {{event.eventName}} - {{event.startTime | date}}
                                    <MatchSummary :connection="connection" :sport="sport" :eventId="event.fixtureId"></MatchSummary>
                                    <MatchWinner :connection="connection" :sport="sport" :tournament="item.tournament" :eventId="event.fixtureId" :eventName="event.eventName" :eventTime="event.startTime"></MatchWinner>
                                </div>
                                <v-card class="grey darken-4">
                                    <v-card-text>
                                        <EventBetTypes :connection="connection" :state="event.gameState" :sport="sport" :tournament="item.tournament" :eventId="event.fixtureId" :eventName="event.eventName" :eventTime="event.startTime"></EventBetTypes>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="[tournaments ? 'upcomingEvents' : 'upcomingEventsNoSport']" expand dark>
            <v-expansion-panel-content class="grey darken-2 mb-1">
                <div slot="header" class="tournament-title">
                    Upcoming Events
                </div>
                <v-card class="grey darken-4">
                    <v-card-text>
                        <UpcomingEvents :connection="connection" :sport="sport"></UpcomingEvents>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import EventBetTypes from './EventBetTypes.vue';
    import TournamentsEventsApi from '../api/tournamentsEvents';
    import { HubConnection } from "@aspnet/signalr";
    import MatchWinner from './MatchWinner.vue';
    import UpcomingEvents from './UpcomingEvents.vue';
    import MatchSummary from './MatchSummary.vue';

    export default {
        name: 'BetOptions',
        components: {
            EventBetTypes,
            MatchWinner,
            UpcomingEvents,
            MatchSummary,
        },
        data() {
            return {
                tournaments: [],
                tournamentPanel: []
            }
        },
        props: {
            sport: String,
            connection: HubConnection,
        },
        watch: {
            sport: function () {
                if (this.sport != '') {
                    this.getTournamentsEvents(this.sport);
                    if (this.connection) {
                        this.connection.on(this.sport + "_fixtureUpdate", (value) => {
                            this.updateFixture(JSON.parse(value));
                        });
                    }
                }
            }
        },
        beforeDestroy() {
            this.connection.off(this.sport + "_fixtureUpdate");
        },
        methods: {
            getTournamentsEvents(sport) {
                TournamentsEventsApi.getTournamentsEvents(sport)
                    .then(data => {
                        this.tournaments = data.responseObject;
                        let tournamentsLength = this.tournaments.length;
                        if (tournamentsLength > 0) {
                            for (let x = 0; x < tournamentsLength; x++) {
                                this.tournamentPanel.push(true);
                            }
                        }
                    })
            },
            updateFixture(updatedFixture) {
                let tournamentIndex = this.tournaments.findIndex(t => t.tournament === updatedFixture.Tournament);
                if (tournamentIndex !== -1) {
                    let i = this.tournaments[tournamentIndex].events.findIndex(t => t.fixtureId === updatedFixture.FixtureID);
                    if (i !== -1) {
                        //found
                        //update fixture name, startTime, etc
                        if (this.tournaments[tournamentIndex].events[i].startTime !== updatedFixture.StartTime)
                            this.tournaments[tournamentIndex].events[i].startTime = updatedFixture.StartTime;
                        if (this.tournaments[tournamentIndex].events[i].eventName !== updatedFixture.EventName)
                            this.tournaments[tournamentIndex].events[i].eventName = updatedFixture.EventName;
                        if (this.tournaments[tournamentIndex].events[i].status !== updatedFixture.Status)
                            this.tournaments[tournamentIndex].events[i].status = updatedFixture.Status;
                        if (this.tournaments[tournamentIndex].events[i].gameState !== updatedFixture.GameState && updatedFixture.GameState !== '') {
                            this.tournaments[tournamentIndex].events[i].gameState = updatedFixture.GameState;
                        }
                    }
                    else {
                        //Add the new event
                        this.tournaments[tournamentIndex].events.push({ "fixtureId": updatedFixture.FixtureID, "eventName": updatedFixture.EventName, "startTime": updatedFixture.StartTime });
                    }
                }
                else {
                    //Add the new tournament
                    this.getTournamentsEvents(this.sport);
                }
            },
            mergeFixture(api, signalR) {
                let temp = api.map(s => s.startTime);
                for (let item in signalR) {
                    let value = signalR[item].Sport;
                    if (temp.indexOf(value) === -1)
                        api.push({ sport: value })
                }
                return api
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tournament-title {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
    }

    .white-color {
        color: #fff;
    }

    .tournament-header {
        background-color: #004369;
    }

    .sub-header {
        color: gold;
        display: block;
    }

    .purple.darken-3, .purple.darken-2 {
        border-top: 1px solid rgba(0,0,0,0.12) !important;
        border-color: #9f9f9f !important;
        font-weight: 600;
    }

    .v-expansion-panel.mb-0.theme--dark > li {
        margin: 0 !important;
    }

    .upcomingEvents {
        padding-top: 20px;
        background-color: #0a0a0a !important;
    }

    .upcomingEventsNoSport {
        padding-top: 0px;
    }

    .grey {
        color: #929292;
    }

    /*.v-expansion-panel.mb-0.theme--dark > li:first-child {
        margin-bottom: 5px !important;
    }*/

</style>

